import React from "react";
import TangentialPolarBar from "../../CHARTS/TangentialPolarBar";
import gf from "../../../img/stock/Green flag.png";
import rf from "../../../img/stock/Red flag.png";
import pdl from "../../../img/stock/PADLOCK.png";
import deto from "../../../img/stock/Detonators.png";
import sc from "../../../img/stock/Safety Chain.png";
import sW from "../../../img/stock/Switch Clamp.png";
import tct from "../../../img/stock/Tri color torch.png";
import ww from "../../../img/stock//Wooden wages.png";
import fb from "../../../img/stock/Fire bucket.png";
import ba from "../../../img/stock/breath analyzer.png";
import str from "../../../img/stock/Stretcher.png";
import tl from "../../../img/stock/Tail lamp.png";
const ItemSlider = ({ data }) => {
  const img = {
    "Red flag": rf,
    "Green flag": gf,
    Detonators: deto,
    PADLOCK: pdl,
    "Safety Chain": sc,
    "Switch Clamp": sW,
    "Tri color torch": tct,
    "Wooden wages": ww,
    "Fire bucket": fb,
    "Breath analyzer": ba,
    Stretcher: str,
    "Tail lamp": tl,
    "Shunt safe": "",
    "FP Gauge": "",
    "BP GAUGES": "",
    Whistle: "",
    "Quick coupling": "",
    "GI bucket": "",
    "LHB Key": "",
    "Steel Almirah": "",
    "office Chair": "",
    "Dragon torch": "",
    "Speed gun": "",
    "R. O .": "",
  };
  const tempDivIItem = data.filter((f) => f.station_code === "DVSN");

  const ChartData = tempDivIItem.map((obj) => {
    const surplus = obj.surplus_short_qty > 0 ? obj.surplus_short_qty : null;
    const sort = obj.surplus_short_qty < 0 ? obj.surplus_short_qty : null;
    return {
      values: surplus
        ? [surplus, obj.required_qty, obj.total_qty]
        : [sort, obj.required_qty, obj.total_qty],
      title: obj.item_name,
    };
  });

  return (
    <div>
      <div className="d-flex align-items-center justify-content-center gap-3">
        <div className="d-flex align-items-center gap-1">
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "#31e649",
              borderRadius: "50%",
            }}
          />
          <span>Surplus </span>
        </div>
        <div className="d-flex align-items-center gap-1">
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "#e63131",
              borderRadius: "50%",
            }}
          />
          <span>Short </span>
        </div>

        <div className="d-flex align-items-center gap-1">
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "#e69831",
              borderRadius: "50%",
            }}
          />
          <span>Required </span>
        </div>

        <div className="d-flex align-items-center gap-1">
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "#526FD6",
              borderRadius: "50%",
            }}
          />
          <span>Available </span>
        </div>
      </div>
      <div className="row border">
        <div
          className="d-flex scrollspy"
          style={{
            overflowX: "auto", // enable horizontal scroll
            overflowY: "hidden",

            whiteSpace: "nowrap", // prevent wrapping
            maxWidth: "100vw", // max container width
            height: "250px", // adjusted for chart height
          }}
        >
          {ChartData &&
            ChartData.map((obj, i) => {
              return (
                <div
                  key={i}
                  className="position-relative flex-shrink-0 m-1"
                  style={{
                    width: "220px",
                    height: "235px",
                  }}
                >
                  {/* Image */}
                  <div
                    className="position-absolute"
                    style={{
                      top: "8px",
                      left: "8px",
                      height: "50px",
                      width: "50px",
                      zIndex: 5,
                    }}
                  >
                    <img
                      alt={obj.title}
                      src={img[obj.title]}
                      style={{
                        height: "50px",
                        width: "50px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Card */}
                  <div
                    className="newUiBody h-100"
                    style={{
                      paddingTop: "15px",
                    }}
                  >
                    <b className="d-block text-center">
                      {obj.title[0].toUpperCase()}
                      {obj.title.slice(1, obj.title.length).toLowerCase()}
                    </b>

                    <TangentialPolarBar
                      values={obj.values}
                      labels={
                        obj.values[0] >= 0
                          ? ["Surplus", "Required", "Available"]
                          : ["Short", "Required", "Available"]
                      }
                      colors={
                        obj.values[0] >= 0
                          ? ["#31e649", "#e69831", "#526FD6"]
                          : ["#e63131", "#e69831", "#526FD6"]
                      }
                      height="150px"
                      fontSize="13px"
                      centerImage={null}
                      centerImageSize={60}
                    />

                    <div className="d-flex align-items-center justify-content-center gap-3">
                      <div className="d-flex align-items-center gap-1">
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            background:
                              obj.values[0] >= 0 ? "#31e649" : "#e63131",
                            borderRadius: "50%",
                          }}
                        />
                        <span>{obj.values[0]}</span>
                      </div>

                      <div className="d-flex align-items-center gap-1">
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            background: "#e69831",
                            borderRadius: "50%",
                          }}
                        />
                        <span>{obj.values[1]}</span>
                      </div>

                      <div className="d-flex align-items-center gap-1">
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            background: "#526FD6",
                            borderRadius: "50%",
                          }}
                        />
                        <span>{obj.values[2]}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>{" "}
    </div>
  );
};
export default ItemSlider;
